import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { SharedService } from '../../services/shared.service';
import { ToPluralPipe } from '../../pipes/toPlural.pipe';

@Component({
  selector: 'app-checkbox-template',
  templateUrl: './checkbox-template.component.html',
  styleUrls: ['./checkbox-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatCheckbox, FormsModule, ReactiveFormsModule, ToPluralPipe],
})
export class CheckboxTemplateComponent implements OnInit, OnChanges {
  private formBuilder = inject(UntypedFormBuilder);
  private sharedService = inject(SharedService);

  @Input() public filterTitle: string;
  @Input() public isAllSelectedOptions: boolean;
  public categoryOptions: Model.CategoryOptions[];
  public title: string;
  public categoryForm: UntypedFormGroup;
  public arr: boolean[];
  public allSelect: boolean;
  @Input() private filterOptions: Model.CategoryOptions[];
  @Input() private clearFilter: boolean;
  @Output() private dirtyFlagChange = new EventEmitter();

  public ngOnInit(): void {
    let isAllPlanSelected: boolean;
    const keyTitle: string = this.title && this.title.toLowerCase().replace(/\s/g, '') + '-values';
    isAllPlanSelected = true;
    this.arr = JSON.parse(sessionStorage.getItem(keyTitle) || '[]');
    this.arr.forEach((val) => {
      isAllPlanSelected = isAllPlanSelected && val;
    });
    const arrLen: number = this.arr && this.arr.length;
    const categoryOptionsLen: number = this.categoryOptions && this.categoryOptions.length;
    if (arrLen === categoryOptionsLen && isAllPlanSelected === true) {
      this.allSelect = true;
    }
    this.sharedService.getClearFilter().subscribe((response) => {
      if (typeof response === 'object' && response !== null && 'status' in response && response.status) {
        const filterArray: boolean[] = this.categoryForm.get('options').value || [];
        if (filterArray.length) {
          filterArray.forEach((_item, index) => {
            this.arr[index] = false;
            filterArray[index] = false;
            this.sharedService.checkboxOption = [];
          });
        }
        sessionStorage.removeItem(response.name && response.name.toLowerCase().replace(/\s/g, '') + '-values');
        sessionStorage.removeItem('filterApplied');
        sessionStorage.removeItem('statusApplied');
        sessionStorage.removeItem('selectedOption');
        this.sharedService.setClearFilter(false);
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.filterOptions) {
      if (changes.filterOptions.currentValue) {
        this.title = this.filterTitle;
        this.categoryOptions = this.filterOptions;
        this.setDefaultValue();
      }
    }
  }

  public onValueChange($event: MatCheckboxChange, index: number, item: Model.CategoryOptions): void {
    item.checked = $event.checked;
    if (!this.arr) {
      this.arr = this.categoryForm.get('options').value;
    }
    this.arr[index] = $event.checked;
    if (item.checked === true) {
      if (this.sharedService.checkboxOption.indexOf(item.name) < 0) {
        this.sharedService.checkboxOption.push(item);
      }
    } else {
      const i: number = this.sharedService.checkboxOption.indexOf(item);
      this.sharedService.checkboxOption.splice(i, 1);
    }
    if (
      this.arr.filter((val) => {
        return val === true;
      })
    ) {
      if (!(this.arr.indexOf(true) > -1)) {
        this.sharedService.checkboxOption.length = 0;
      }
      if (this.sharedService.checkboxOption.length === this.categoryOptions.length) {
        this.allSelect = true;
      } else {
        this.allSelect = false;
      }
      const optionsStatus: Model.SelectedFilterOptions = {
        selectedOptions: this.sharedService.checkboxOption,
        status: this.arr,
      };
      this.dirtyFlagChange.emit(optionsStatus);
    } else {
      this.dirtyFlagChange.emit(item);
    }
  }

  public onSelectAll($event: MatCheckboxChange): void {
    this.categoryOptions.forEach((element, index) => {
      element.checked = $event.checked;
      if ($event.checked) {
        this.arr[index] = $event.checked;
        this.sharedService.checkboxOption.push(element);
      } else {
        this.arr.length = 0;
        this.sharedService.checkboxOption.length = 0;
      }
      const optionsStatus: Model.SelectedFilterOptions = {
        selectedOptions: this.sharedService.checkboxOption,
        status: this.arr,
      };
      this.dirtyFlagChange.emit(optionsStatus);
    });
  }

  private setDefaultValue(): void {
    const controls: UntypedFormControl[] = this.categoryOptions.map(() => new UntypedFormControl(false));
    this.categoryForm = this.formBuilder.group({
      options: this.formBuilder.array(controls),
    });
  }
}
